import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import UpgradePlanModal from '~/components/UpgradePlanModal';

const UpgradePlanModalContext = createContext();

export const useUpgradePlanModal = () => {
    return useContext(UpgradePlanModalContext);
};

export const UpgradePlanModalProvider = ({ children }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);

    const showUpgradePlanModal = useCallback((data = null) => {
        setModalData(data);
        setShowModal(true);
    }, []);

    const hideUpgradePlanModal = useCallback(() => {
        setShowModal(false);
        setModalData(null);
    }, []);

    const contextValue = useMemo(() => ({ showUpgradePlanModal, hideUpgradePlanModal }), [showUpgradePlanModal, hideUpgradePlanModal]);

    return (
        <UpgradePlanModalContext.Provider value={contextValue}>
            {children}
            <UpgradePlanModal show={showModal} onClose={hideUpgradePlanModal} initialData={modalData} />
        </UpgradePlanModalContext.Provider>
    );
};
